import useSolarConcertSellerReadiness from "~/api/hooks/useSolarConcertSellerReadiness"
import {
  ConcertAccountStatusBanner,
  ConcertAccountStatusErrorBanner,
  ConcertAccountStatusLoadingBanner,
  getConcertUserStatusFailures,
} from "~/components/Concert/ConcertAccountStatusBanner"

/**
 * V1's Concert account gate for a Solar Proposal: what the seller's (or
 * mentor's) Concert user is missing before an application can be submitted.
 * Renders nothing once the seller is ready.
 */
export const SolarConcertSellerBanner = ({
  proposalId,
}: {
  proposalId: string
}): JSX.Element | null => {
  const readiness = useSolarConcertSellerReadiness(proposalId)
  if (readiness.isLoading) {
    return <ConcertAccountStatusLoadingBanner />
  }
  const { data } = readiness
  if (readiness.isError || data?.status === `unavailable`) {
    return <ConcertAccountStatusErrorBanner />
  }
  if (data == null || data.status === `ready` || data.checks == null) {
    return null
  }
  return (
    <div data-testid="solar-concert-seller-not-ready">
      <ConcertAccountStatusBanner
        failures={getConcertUserStatusFailures(data.checks)}
      />
    </div>
  )
}
